define('taoQtiItem/qtiCreator/widgets/item/states/states',[
    'taoQtiItem/qtiCreator/widgets/states/factory',
    'taoQtiItem/qtiCreator/widgets/item/states/Active'
], function(factory){
    return factory.createBundle(arguments);
});
